import { useGraphQuery } from "@dashboard/library";
import { GetPlaybookResults } from "@/graphql/queries/GetPlaybookResults";

export const useGetPlaybookResults = (callId?: string | null) => {
  const result = useGraphQuery(GetPlaybookResults, {
    variables: { input: { callId: callId ?? "" } },
    skip: !callId,
    // The playbook is one section of the Insights tab, and this hook also runs in
    // DataAccessLayer. A failure here must degrade to an empty section, not throw
    // and crash the whole page. [CI-6183]
    throwError: false,
  });

  return {
    ...result,
    playbookResult: result.output?.getPlaybookResults?.items?.[0],
  };
};
